import useDocumentCreator from "../../../engine/hooks/useDocumentCreator";
import dayjs from "../../../utils/dayjs";
import {
  daysJsFormat,
  languagesList,
  renderStatusLabels,
  renderTypePrestation,
  renderUserName,
  statusPrestations,
  statusPrestationsValues,
} from "../../../utils/constants";
import { Excel } from "antd-table-saveas-excel";
import { Button } from "antd";
import { AiFillFileExcel } from "react-icons/ai";
import React from "react";
import { useSelector } from "react-redux";
import { FilePdfOutlined } from "@ant-design/icons";
import { http } from "../../../engine/api/http";
import { renderStringAddress } from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";
import { useTranslation } from "react-i18next";

export const InstitutionsExportFile = ({ type, institutions }) => {
  const { bills } = useSelector((state) => state.billing);
  const { t } = useTranslation(); // Use useTranslation hook
  
  const [loading, setLoading] = React.useState(false);

  const exportExcel = async () => {
    setLoading(true);
    const exportColumns = [
      {
        title: t("InstitutionsExportFile.columns.name"),
        dataIndex: "name",
      },
      {
        title: t("InstitutionsExportFile.columns.secondName"),
        dataIndex: "secondName",
      },
      {
        title: t("InstitutionsExportFile.columns.mainType"),
        dataIndex: "mainType",
      },
      {
        title: t("InstitutionsExportFile.columns.interventionLocation"),
        dataIndex: "interventionLocation",
      },
      {
        title: t("InstitutionsExportFile.columns.address"),
        dataIndex: "address",
      },
      {
        title: t("InstitutionsExportFile.columns.total"),
        dataIndex: "total",
      },
      {
        title: `Total ${
          statusPrestations.find(
            (e) => e.value === statusPrestationsValues.draft
          ).label
        }`,
        dataIndex: statusPrestationsValues.draft,
      },
      {
        title: `Total ${
          statusPrestations.find((e) => e.value === statusPrestationsValues.cancel)
            .label
        }`,
        dataIndex: statusPrestationsValues.cancel,
      },
      {
        title: `Total ${
          statusPrestations.find((e) => e.value === statusPrestationsValues.finish)
            .label
        }`,
        dataIndex: statusPrestationsValues.finish,
      },
      {
        title: `Total ${
          statusPrestations.find((e) => e.value === statusPrestationsValues.planned)
            .label
        }`,
        dataIndex: statusPrestationsValues.planned,
      },
      {
        title: `Total ${
          statusPrestations.find((e) => e.value === statusPrestationsValues.waiting)
            .label
        }`,
        dataIndex: statusPrestationsValues.waiting,
      },
    ];

    const stats = await http.get("prestations/stats");

    const mutateData = () => {
      let newArr = [];

      institutions.map((institu) => {
        let ins = stats.data.find((e) => e.institutionId === institu._id);

        newArr.push({
          ...institu,
          address: renderStringAddress(institu?.defaultAddress),
          total: ins?.total || 0,
          cancel:
            ins?.byStatus?.cancel ||
            0 + ins?.byStatus?.cancelClient ||
            0 + ins?.byStatus?.cancelInterprete ||
            0 + ins?.byStatus?.cancelAvic ||
            0,
          draft: ins?.byStatus?.draft || 0,
          finish:
            ins?.byStatus?.finish ||
            0 + ins?.byStatus?.finish_notsigned ||
            0 + ins?.byStatus?.finish_permanance ||
            0,
          planned: ins?.byStatus?.planned || 0,
          waiting: ins?.byStatus?.waiting || 0,
          // createdAt: institu?.createdAt,
          // _id: institu?._id,
          // name: institu?.name,
          // secondName: institu?.secondName,
          // mainType: institu?.mainType,
          // interventionLocation: institu?.interventionLocation,
        });
      });
      return newArr;
    };

    const excel = new Excel();
    excel.addSheet("Institutions")
      .addColumns(exportColumns)
      .addDataSource(mutateData())
      .saveAs("institutions.xlsx");
    setLoading(false);
  };

  return (
    <>
      <Button
        type="default"
        size="large"
        icon={<AiFillFileExcel />}
        disabled={institutions.length === 0}
        loading={loading}
        onClick={exportExcel}
      >
        {t("InstitutionsExportFile.button.exportExcel")}
      </Button>
    </>
  );
};
